module.exports = __webpack_public_path__ + "img/mobile/BetBar/Menu_button@2x.png?0.0.53";